import * as React from "react";
import { Col, Table, notification, Pagination, Row } from "antd";
import { useGlobalStore } from "../../../contexts/StoreContext";
import { getCasePayload, getCasePayloadType } from "../../../utils";
import { adminCasesTableColumn } from "../../../components/Dashboards/Tables/Columns";
import { getAdminActiveCases } from "../../../services/adminController";
import {
  getAgentActiveCases,
  getAgentPendingCases,
} from "../../../services/agentController";
import {
  getAgentManagerActiveCases,
  getAgentManagerPendingCases,
} from "../../../services/agentManagerController";

interface TableViewProps {
  tableProps: any;
  caseType: string;
}

export const TableView: React.FC<TableViewProps> = ({
  tableProps,
  caseType = "adminActive",
}) => {
  const [states, setStates] = React.useState({
    loader: true,
    page: 1,
    pageSize: 10,
    caseData: [],
    totalRecords: 0,
  });

  const { state, dispatch } = useGlobalStore();
  const { activeTabKey } = state;
  const payload = getCasePayload(state);
  const casePayloadType: any = getCasePayloadType(activeTabKey);
  const [api] = notification.useNotification();

  const fetchCaseData = React.useCallback(async () => {
    setStates((prev) => ({ ...prev, loader: true }));
    const updatedPayload = {
      ...getCasePayload(state),
      page: states.page,
      size: states.pageSize,
    };
    console.log("#>>> fetchCaseData() => updatedPayload :: ", state);
    let res: any = null;

    if (caseType === "adminActive") {
      res = await getAdminActiveCases(updatedPayload);
    }
    if (caseType === "agentPending") {
      res = await getAgentPendingCases(updatedPayload);
    }
    if (caseType === "agentActive") {
      res = await getAgentActiveCases(updatedPayload);
    }
    if (caseType === "managerPending") {
      res = await getAgentManagerPendingCases(updatedPayload);
    }
    if (caseType === "managerActive") {
      res = await getAgentManagerActiveCases(updatedPayload);
    }
    console.log("res", caseType, res);
    if (res?.status !== 200) {
      setStates((prev) => ({ ...prev, loader: false, caseData: res?.data }));
      return;
    }

    const newData = Array.isArray(res.data) ? res.data : [];
    // const combinedData =
    //   states.page === 1 ? newData : [...states.caseData, ...newData];
    const uniqueDataMap = new Map<string | number, any>();

    newData?.forEach((item: any) => {
      if (item && item.loanId !== undefined) {
        uniqueDataMap.set(item.loanId, item);
      }
    });

    const uniqueCaseData = Array.from(uniqueDataMap.values());

    setStates((prev: any) => ({
      ...prev,
      caseData: uniqueCaseData,
      totalRecords: res.totalResults ?? prev.totalRecords,
      loader: false,
    }));
  }, [states.page, states.pageSize, caseType, state]);

  const handleOnChangePage = (page: number, pageSize: number) => {
    setStates((prev) => ({ ...prev, page, pageSize }));
  };

  React.useEffect(() => {
    fetchCaseData();
  }, [
    fetchCaseData,
    states.page,
    states.pageSize,
    activeTabKey,
    state.completedCasePayload,
    state.pendingCasePayload,
    state.activeCasePayload,
  ]);

  const handleSorting = React.useCallback((page: number, pageSize: number) => {
    setStates((prev) => ({ ...prev, page, pageSize }));
    return {};
  }, []);

  const openNotification = (title?: string, description?: string) => {
    api.open({
      message: title || "Solveesy",
      description: description || "",
      duration: 3,
    });
  };

  React.useEffect(() => {
    const tempTableData = states.caseData as any;
    if (tempTableData && Object.hasOwnProperty.call(tempTableData, "info")) {
      openNotification("", tempTableData?.info);
    }
  }, [states.caseData]);

  return (
    <Col>
      <Table
         {...tableProps}
        loading={states.loader}
        onChange={(selectedRowKeys, selectedRows, info: any) => {
          handleSorting(info?.field, info?.order);
        }}
        columns={adminCasesTableColumn}
        dataSource={states.caseData || []}
        size="middle"
        pagination={false}
        onRow={(rowInfo) => ({
          onClick: () => {
            // implement multiple selection
          },
        })}
        style={{ cursor: "pointer" }}
      scroll={{ y: 850 }}      // required
       virtual  
      />
      <Row className="flex justify-center pt-6 pb-6">
        <Pagination
          showSizeChanger
          pageSize={states.pageSize}
          total={states.totalRecords}
          onChange={handleOnChangePage}
          current={states.page}
          pageSizeOptions={['10', '20', '50', '100','500','1000']}
        />
      </Row>
    </Col>
  );
};
